import { useTranslation } from "react-i18next"
import { Attentions, PageHeader, WidgetModal, EsfSystemControls, SystemOverviewLayout, CardNumberDisplayList } from "../../../../Components"
import { colors, decors, frames, glyphs } from "../../../../Styles"
import { useEffect, useMemo, useState } from "react"
import { WidgetPlacements } from "../../../../Definitions"
import { useLocation, useParams } from "react-router"
import { useAppDispatch, useAppSelector } from "../../../../Store"
import { Graph_QL, useAnimal, useWidget, Widget } from "../../../../Services"
import AllWidgets from "../../../../Components/Widgets/_Widgets/allWidgets"
import { useSystemInfoById } from "../../../../Services/Agrisys_GqlDataCaller/SystemCalls/systemSlice"
import { selectLocationsBySystem, useLocationById } from "../../../../Services/Agrisys_GqlDataCaller/SectionsCalls/locationSlice"
import { isEqual } from "lodash"
import { dispatchFetchSectionBySystem, selectSectionsBySystem } from "../../../../Services/Agrisys_GqlDataCaller/SectionsCalls/sectionsSlice"
import { glyph } from "../../../../Components/BaseComponents/cardNumberDisplay"
import { useAnimalById } from "../../../../Services/Agrisys_GqlDataCaller/AnimalDataCalls/AnimalDataSlices/animalsSlice"
import { Animal } from "../../../../Services/Agrisys_GqlDataCaller/AnimalDataCalls/GQLCalls/getAnimalCall"
import { SystemOverviewAreas } from "../../../../Styles/frames"

export default function Freeda_esf() {
  const { t } = useTranslation();
  const { systemId: urlSystemId } = useParams();
  
  const appDispatch = useAppDispatch();
  const location = useLocation();
  const systemId = useMemo(() => (urlSystemId ? +urlSystemId : location?.state?.selected), [urlSystemId, location]);

  const [widgetModal, setWidgetModal] = useState<boolean>(false)
  
  // #region | GraphQl
  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";
  const { domain, connection } = useMemo(() => {
    let domain = Graph_QL.ObjToString({ domain: farm });
    let connection = Graph_QL.create({ domain: farm });
    return { domain, connection };
  }, [farm]);
      
  appDispatch(dispatchFetchSectionBySystem(systemId));  

  const { isLoading, entity: system } = useSystemInfoById(systemId)

  // const sections = useAppSelector((state) => selectSectionsBySystem(state, systemId), isEqual);
  const locations = useAppSelector((state) => selectLocationsBySystem(state, [systemId]), isEqual);
  // #endregion
  
  // #region | System Controls
  const SystemControlsComponent = useMemo(() => {
    return system && <EsfSystemControls system={system} key={systemId} /> 
  }, [system, systemId]);
  // #endregion

  // #region | Attentions
  const AttentionsComponent = useMemo(() => (
    system && <Attentions system={system} height={"100%"} connect={{connection: connection, domain: domain}}/>
  ), [connection, domain, system]);
  // #endregion

  // #region | Widgets
  const { call: getWidgetInfo, data: widgetState } = useWidget(connection);
  const { call: getAnimals, data: animalState } = useAnimal(connection)

  useEffect(() => {
    getWidgetInfo({}, connection);
    getAnimals({ ifSkipLastTenDaysConsumption: false, offset: 0}, connection)
  }, [connection]);
  
  const widgets = useMemo<Widget[]>(() => { return widgetState[domain]?.data ?? [] }, [widgetState, domain])
  const animals = useMemo<Animal[]>(() => { return animalState[domain]?.data ?? [] }, [animalState, domain])

  const animalsInSystem = useMemo(() => {
    const locationAnimalIds = locations.flatMap(loc => loc.animals).map(a => a.animal_id);
  
    return animals.filter(a =>
      locationAnimalIds.includes(a.animal_id)
    );
  }, [animals, locations]);

  const AllWidgetsComp = useMemo(() => (
    <AllWidgets
      widgets={widgets}
      animals={animalsInSystem}
      system={system}
      placement={WidgetPlacements.system}
      connect={{
        domain: domain,
        connection: connection
      }}
    />
  ), [connection, domain, system, widgets, animalsInSystem])
  // #endregion

  // #region | Card Number Display List
  const CardDisplayCompnent = useMemo(() => (
    <CardNumberDisplayList
      values={[locations.length, locations.flatMap(loc => loc.stations).length, locations.flatMap(loc => loc.animals).length]}
      units={[
        t("esfWalkThroughPages.esfWalkThrough.pens", { defaultValue: "pens" }),
        t("esfWalkThroughPages.esfWalkThrough.stations", { defaultValue: "stations" }),
        t("esfWalkThroughPages.esfWalkThrough.animals", { defaultValue: "animals" })
      ]}
      glyphs={[
        glyph(<img alt="enhancer" src={decors.def_bg} style={{ width: "319px", opacity: "0.1", transform: "scaleX(-1)" }} />, -33, undefined, undefined, 0),
        glyph(<img alt="enhancer" src={decors.def_bg} style={{ width: "319px", opacity: "0.1", transform: "scaleX(-1)" }} />, -33, 0, undefined, undefined),
        glyph(<img alt="enhancer" src={decors.def_bg} style={{ width: "319px", opacity: "0.1", transform: "scaleX(-1)" }} />, undefined, undefined, -3, 0)
      ]}
    />
  ), [t, locations])
  // #endregion

  return (
    <frames.Page_inner>
      <PageHeader
        zIndex={99}
        topHeader={system?.name}
        subHeader={t("menuHeaders.overview", { defaultValue: "overview" })}
        optionButtons={{
          contents: [t("widgets.general.widgetOptions", {defaultValue: "widget options"})],
          onClick: (i => {
            if (i === 0) { setWidgetModal(true) };
          })
        }}
      />
      
      <frames._page_inner_content>
        <SystemOverviewLayout
          cardDisplayComponent={CardDisplayCompnent}
          systemControlsComponent={SystemControlsComponent}
          attentionsComponent={AttentionsComponent}
          widgetComponents={ AllWidgetsComp}
        />
      </frames._page_inner_content>

      <WidgetModal widgets={widgets} closeModal={() => setWidgetModal(false)} connect={{connection: connection, domain: domain}} isModalOpen={widgetModal} system={system} placement={WidgetPlacements.system}/>
    </frames.Page_inner>
  )
}
